/** Who reacted with what, for one item: one batched request per screen (see batcher.ts). Split out of ReactionBar (t295u). */
import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import { useMembers, useWorkspaceId } from '@/lib/hooks';
import { createEntityReactorBatcher, createReactorBatcher, type ReactorKind } from './batcher';

const batcher = createReactorBatcher((ws, b) => api.reactors(ws, b));
const entityBatcher = createEntityReactorBatcher((ws, type, ids) => api.itemReactors(ws, type, ids));

export interface PillData { emoji: string; count: number; user_ids: string[] }

export function useReactors(kind: ReactorKind, id: string, pills: PillData[]) {
  const ws = useWorkspaceId();
  const sig = pills.filter(p => p.count > 0).map(p => `${p.emoji}:${p.user_ids.join('.')}`).join('|');
  const { byId } = useMembers();
  const q = useQuery({
    queryKey: ['reactors', kind, id, sig],
    // t255u: feed items ask /threads/:type/reactors (names for people outside the member list too); id is "type:id".
    queryFn: () => (kind === 'entity' ? entityBatcher.load(ws!, id.slice(0, id.indexOf(':')), id.slice(id.indexOf(':') + 1)) : batcher.load(ws!, kind, id)),
    enabled: Boolean(ws && sig),
    staleTime: Infinity,
    retry: kind === 'entity' ? false : undefined,
  });
  if (kind !== 'entity' || q.data) return q;
  // t184u: until then (or if that fails) the names come from the workspace members already loaded.
  const data = byId.size ? Object.fromEntries(pills.map(p => [p.emoji, p.user_ids.map(u => ({ user_id: u, display_name: byId.get(u)?.display_name ?? 'Someone' }))])) : undefined;
  return { data, isLoading: !byId.size && Boolean(sig) };
}
